@if (timerWidgetShown) {
  <aside class="timer-widget">
    @if (image) {
      <img
        [src]="image.url"
        [alt]="image.alternativeText"
        class="timer-widget__image"
        wlAutomationId="timer-widget-image"
      />
    }
    <div class="timer-widget__body">
      @if (title) {
        <span
          class="timer-widget__body__title"
          wlAutomationId="timer-widget-title"
        >
          {{ title }}
        </span>
      }
      @if (text) {
        <span wlAutomationId="timer-widget-text">{{ text }}</span>
      }
      <wl-timer
        [dateToCountDownTo]="dateToCountDownTo"
        [labels]="timerLabels"
        (timerEnded)="hideTimerWidget()"
      />
    </div>
  </aside>
}
